import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { TypeChecker } from '@attain-apps/type-guards'

import * as state from '../../../../../../../../../../state'

@ngCore.Component({
  imports: [
    ngCommon.KeyValuePipe,
    ngCommon.NgForOf,
    ngCommon.TitleCasePipe,
    ds.input.select.single.Component,
    ds.layout.section.Component,
  ],
  selector: 'atn-details-tab',
  standalone: true,
  styleUrls: ['./details-tab.component.scss'],
  templateUrl: './details-tab.component.html',
})
export class AtnDetailsTabComponent {
  /** @see {@link state.rate.gl.EcInjector} */
  private readonly _glEc = ngCore.inject(state.rate.gl.records.Collection)

  /**
   * TODO: document
   */
  public readonly selectedRecordAttributesSg = ngCore.computed(
    (
      attributeIds = this._glEc.plugins.attributePlugin.feature.selectors.attributes
        .asSignal()
        .map(attribute => attribute.id),
      glRecord = this._glEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => {
      const filteredAttributes = glRecord?.attributes?.filter(attribute =>
        attributeIds.includes(attribute.id),
      )

      const atts = filteredAttributes?.reduce(
        (previousValue, currentValue) => {
          this._glEc.plugins.attributePlugin.feature.selectors.attributes
            .asSignal()
            .forEach(attribute => {
              if (currentValue.id === attribute.id) {
                Object.assign(previousValue, {
                  [attribute.name]: TypeChecker.isObject(currentValue.value)
                    ? JSON.stringify(currentValue.value)
                    : currentValue.value,
                })
              }
            })
          return previousValue
        },
        {} as Record<
          ents.core.common.Named['name'],
          ents.core.common.value.Raw
        >,
      )

      return atts
    },
  )
}
